export default "__VITE_ASSET__yzgj18ED__"